// src/services/reviewsAPI.js

const getBase = () =>
  process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/api/v1`
    : '/api/v1';

const authHeader = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchAllReviews = async () => {
  const res = await fetch(`${getBase()}/reviews`, {
    headers: { 'Content-Type': 'application/json', ...authHeader() },
  });
  if (!res.ok) throw new Error('Failed to fetch reviews');
  return res.json();
};

export const fetchCarReviews = async (carId) => {
  const res = await fetch(`${getBase()}/cars/${carId}/reviews`, {
    headers: { 'Content-Type': 'application/json', ...authHeader() },
  });
  if (!res.ok) throw new Error('Failed to fetch car reviews');
  return res.json();
};

export const createReview = async ({ carId, rating, comment }) => {
  const res = await fetch(`${getBase()}/reviews`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ review: { car_id: carId, rating, comment } }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.errors?.join(', ') || 'Failed to submit review');
  }
  return res.json();
};

export const updateReview = async (id, { rating, comment }) => {
  const res = await fetch(`${getBase()}/reviews/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ review: { rating, comment } }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.errors?.join(', ') || 'Failed to update review');
  }
  return res.json();
};

export const fetchReviewForm = async (token) => {
  const res = await fetch(`${getBase()}/reviews/form/${token}`, {
    headers: { 'Content-Type': 'application/json' },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Invalid link');
  return data;
};

export const submitReviewByToken = async (token, { rating, comment, category }) => {
  const res = await fetch(`${getBase()}/reviews/submit/${token}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ rating, comment, category }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || data.errors?.join(', ') || 'Submission failed');
  return data;
};


const adminAuthHeader = () => {
  const token = localStorage.getItem('adminToken') || localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminFetchReviews = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status)      params.set('status',      filters.status);
  if (filters.review_type) params.set('review_type', filters.review_type);
  const res = await fetch(`${getBase()}/admin/reviews?${params}`, {
    headers: { 'Content-Type': 'application/json', ...adminAuthHeader() },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to fetch reviews');
  return data;
};

export const adminSendReviewLink = async ({ customer_name, customer_phone, review_type, car_id }) => {
  const res = await fetch(`${getBase()}/admin/reviews/send_link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...adminAuthHeader() },
    body: JSON.stringify({ customer_name, customer_phone, review_type, car_id }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.errors?.join(', ') || data.error || 'Failed to send link');
  return data;
};

export const adminApproveReview = async (id, adminNote = '') => {
  const res = await fetch(`${getBase()}/admin/reviews/${id}/approve`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...adminAuthHeader() },
    body: JSON.stringify({ admin_note: adminNote }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to approve');
  return data;
};

export const adminRejectReview = async (id, adminNote = '') => {
  const res = await fetch(`${getBase()}/admin/reviews/${id}/reject`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...adminAuthHeader() },
    body: JSON.stringify({ admin_note: adminNote }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to reject');
  return data;
};

export const adminDeleteReview = async (id) => {
  const res = await fetch(`${getBase()}/admin/reviews/${id}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...adminAuthHeader() },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to delete');
  return data;
};